<template>
  <div>
    <b-card
        header="🩺 Health Profile"
        style="margin-bottom: 15px"
    >
      <b-card-text>
        <b-row>
          <b-col>
            <b-form-group
                label-for="input-6"
                class="custom-label"
            >
              <label-info
                  id="popover-target-medication-name"
                  label-name="Name"
                  label-info="How experienced is this heartbeat"
              />
              <h6>{{formHealth.user_info.name}}</h6>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                label-for="input-6"
                class="custom-label"
            >
              <template
                  v-if="formHealth.user_info.age" >
                <label-info
                    id="popover-target-medication-name"
                    label-name="Age"
                    label-info="How experienced is this heartbeat"
                />
                <h6>{{formHealth.user_info.age}}</h6>
              </template>
              <b-form-group
                  v-else
                  id="icon"
                  label="Birthday Date"
                  label-for="input-2"
                  class="custom-label"
              >
                <b-input-group>
                  <b-form-input
                      id="birthdate"
                      class="custom-input"
                      type="date"
                      v-model.trim="birthdate"
                      @blur="handleBirthdateChange"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                label-for="input-6"
                class="custom-label"
            >
              <label-info
                  id="popover-target-medication-name"
                  label-name="Gender"
                  label-info="Your biologically assigned gender at birth. We do have more details in your Proifle"
              />
              <h6 v-if="formHealth.user_info.gender">{{formHealth.user_info.gender}}</h6>
              <b-dropdown
                  v-else
                  size="sm"
                  class="m-2"
              >
                <template #button-content>
                  {{ formHealth.user_info && formHealth.user_info.gender ? formHealth.user_info.gender : 'Add Gender'}}
                </template>
                <b-dropdown-item-button
                    @click="handleGenderSelectionClick('Male')"
                >
                  Male
                </b-dropdown-item-button>
                <b-dropdown-item-button
                    @click="handleGenderSelectionClick('Female')"
                >
                  Female
                </b-dropdown-item-button>
              </b-dropdown>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
                label-for="input-6"
                class="custom-label"
            >
              <label-info
                  id="popover-target-medication-name"
                  label-name="Imperial/Metric"
                  label-info="Most countries use the metric system which uses the measuring units such as meters and grams, and adds prefixes like kilo, milli, and centi to count orders of magnitude. In the United States, we use the older imperial system, where things are measured in feet, inches, and pounds."
              />
              <h6 v-if="formHealth.user_info.isImperial">
                {{ formHealth.user_info.isImperial ? 'Imperial' : 'metric' }}
              </h6>
            <toggle-single
                v-else
                id="metric"
                :toggle-model="isImperial"
                :label-name="isImperial ? 'imperial':'metric'"
                @toggle-click="handleIsImperialToggleClick"
                />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                label-for="input-6"
                class="custom-label"
            >
              <label-info
                  id="popover-target-medication-name"
                  label-name="Height"
                  label-info="How experienced is this heartbeat"
              />
              <h6 v-if="formHealth.user_info.height">
                {{formHealth.user_info.height}}
              </h6>
              <the-mask v-else
                        id="input-1"
                        v-model="formHealth.user_info.height"
                        type="tel"
                        :mask="[`#'##`]"
                        placeholder="5'11"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                label-for="input-6"
                class="custom-label"
            >
              <label-info
                  id="popover-target-medication-name"
                  label-name="Weight"
                  label-info="Info about eight"
              />
              <h6 v-if="formHealth.user_info.weight">{{ formHealth.user_info.weight }}</h6>
              <the-mask
                  v-else
                  id="input-1"
                  v-model="formHealth.user_info.weight"
                  type="tel"
                  :mask="[`### lbs`]"
                  placeholder="120 lbs"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
                label-for="input-6"
                class="custom-label"
            >
              <label-info
                  id="popover-target-medication-name"
                  label-name="Medical History"
                  label-info="Detailed"
              />
              <h6 v-if="formHealth.user_info.medicalHistory">
                {{formHealth.user_info.medicalHistory}}
              </h6>
              <the-mask
                  v-else
                  id="input-1"
                  v-model="formHealth.user_info.height"
                  type="tel"
                  :mask="isImperial ? [`#'##`]:[`### kg`]"
                  :placeholder="isImperial ? `5'11`:`100 m`"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #footer>
       <toggle-single
           v-if="showAddNewHealthDataToggle"
           id="health-profile-toggle"
           label-name="Add Additional Data to a Health Profile"
           label-info="We will use this information to create a Health Profile"
           :toggle-model="shallAddNewDataToHealthProfile"
           @toggle-click="handleHealthProfileToggleClick"
       />
      </template>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import LabelInfo from "@/components/blockResources/_components/labelInfo";
import ToggleSingle from "@/components/blockResources/_components/toggleSingle";
import TheMask from "vue-the-mask/src/component";

export default {
  name: "Bend_HealthProfile",
  components: {
    LabelInfo,
    ToggleSingle,
    TheMask
  },
  created(){
    debugger;
    if(this.profile){
      this.fillInHealthInfo(this.formHealth);
    }
  },
  props: {
    profile: {
      type: Object,
      default: ()=>{return {}}
    },
    formHealth: {
      type: Object,
      default: ()=>{return {}},
      required: true
    }
  },
  computed: {
    ...mapGetters({})
  },
  methods: {
    handleHealthProfileToggleClick(){
      this.shallAddNewDataToHealthProfile = !this.shallAddNewDataToHealthProfile;
    },
    handleIsImperialToggleClick(){
      this.isImperial = !this.isImperial;
    },
    fillInHealthInfo(formBend){
      debugger;

      if (!this.formHealth.user_info) this.formHealth.user_info = {};

      //UserProfile- General
      if (this.profile && this.profile.firstname) {
        this.formHealth.user_info.name = this.profile.firstname;
        this.formHealth.user_info.name = this.profile.lastname ?
            `${this.formHealth.user_info.name} ${this.profile.lastname}` : '';
      } else {
        this.formHealth.user_info.name = null;
        this.showAddNewHealthDataToggle = true;
      }

      if (this.profile && this.profile.birthdate) {
        formBend.user_info.age = this.profile.birthdate ? this.getAgeFromBirthdate(this.profile.birthdate) : 21;
      }else{
        formBend.user_info.age = null;
        this.showAddNewHealthDataToggle = true;
      }

      //Health
      if (this.profile && this.profile.healthProfile){
        //Personal Info
        if(this.profile.healthProfile.personalInfo) {
          formBend.user_info.gender = this.profile.healthProfile.personalInfo.gender ? this.profile.healthProfile.personalInfo.gender : null;

          formBend.user_info.height = this.profile.healthProfile.personalInfo &&
          this.profile.healthProfile.personalInfo.height ? this.profile.healthProfile.personalInfo.height : null;

          formBend.user_info.weight = this.profile.healthProfile.personalInfo &&
          this.profile.healthProfile.personalInfo.weight ? this.profile.healthProfile.personalInfo.weight : null;
        }

        //Medical History
        if(this.profile.healthProfile.medicalHistory) {
          formBend.user_info.medicalHistory =  "Arthritis, High Blood Pressure";
          /*
              this.profile.healthProfile.medicalHistory.issues  &&
              Array.isArray(this.profile.healthProfile.medicalHistory.issues)  ?
                  this.profile.healthProfile.medicalHistory.issues : [];
           */
        }
      }else{
       // formBend.user_info.age = null;
        this.showAddNewHealthDataToggle = true;
      }
    },
    getAgeFromBirthdate(birthdate) {
      debugger;
      let age =  moment().diff(birthdate, 'years',false);
    return age;
    },
    handleBirthdateChange(){
      debugger;
      if(this.birthdate){
        this.formHealth.user_info.age = this.getAgeFromBirthdate(this.birthdate) ;
      }
    },
    handleGenderSelectionClick(gender){
      this.formHealth.user_info.gender = gender;
    }
  },
  data() {
    return {
      birthdate: null,
      isImperial: true,
      showAddNewHealthDataToggle: false,
      shallAddNewDataToHealthProfile: true
    };
  }
};
</script>

<style lang="scss" scoped></style>
